"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = require("debug");
var nanoid_1 = require("nanoid");
var count = 0;
var noop = function () { };
var debug = debug_1.default('jsonp');
exports.default = (function (url, opts, fn) {
    if ('function' == typeof opts) {
        fn = opts;
        opts = {};
    }
    var _root = window;
    if (!opts)
        opts = {};
    var prefix = opts.prefix || '__jp';
    var id = opts.name || (prefix + nanoid_1.nanoid(3) + (count++));
    var param = opts.param || 'callback';
    var timeout = null != opts.timeout ? opts.timeout : 60000;
    var enc = encodeURIComponent;
    var target = document.getElementsByTagName('script')[0] || document.head;
    var script;
    var timer;
    if (timeout) {
        timer = setTimeout(function () {
            cleanup();
            if (fn)
                fn(new Error('Timeout'));
        }, timeout);
    }
    function cleanup() {
        if (script.parentNode)
            script.parentNode.removeChild(script);
        _root[id] = noop;
        if (timer)
            clearTimeout(timer);
    }
    function cancel() {
        if (_root[id]) {
            cleanup();
        }
    }
    _root[id] = function (data) {
        debug('jsonp got', data);
        cleanup();
        if (fn)
            fn(null, data);
    };
    url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
    url = url.replace('?&', '?');
    debug('jsonp req "%s"', url);
    script = document.createElement('script');
    script.src = url;
    target.parentNode.insertBefore(script, target);
    return cancel;
});
//# sourceMappingURL=jsonp.js.map